<template>
	<BaseLayout background-color-class="bg-color-white" :content-full-height="true">
		<template #header>
			<HeaderBasic :cancel-modal="cancelModal" />
		</template>

		<section class="grid container">
			<div class="col-12 col-6-md col-offset-3-md">
				<slot>
					<router-view v-slot="{ Component }">
						<TransitionSubpage>
							<component :is="Component" />
							<template #bottom-content> </template>
						</TransitionSubpage>
					</router-view>
				</slot>
			</div>
		</section>
	</BaseLayout>
</template>

<script setup lang="ts">
import CancelConfirmationModal from '@components/header/cancel-confirmation-modal.vue';
import HeaderBasic from '@components/header/header-basic.vue';
import TransitionSubpage from '@components/layout/transition-subpage.vue';
import { useHead } from '@unhead/vue';

const cancelModal = {
	modal: CancelConfirmationModal,
	props: {
		redirect: 'home'
	}
};

function setup(): void {
	useHead({
		title: 'Open Your Account',
		meta: [{ property: 'og:title', content: 'Open Your Account' }]
	});
}

setup();
</script>
